import React, { useEffect, useState } from 'react'
import ListinngCard from '../../layouts/ListingCard';
import { useNavigate } from 'react-router-dom';
import { app } from '../../config';
import getHeaders from '../../utils/authHeaders';
import axios from 'axios';

const FacialPackagesListing = () => {
  const [pagesCount, setPagesCount] = useState(0);
  const [pageSize, setPageSize] = useState(10);

     const [tableHeaders, setTableHeaders] = useState([]);
     const [renderList, setrenderList] = useState(false);
     const [loader, setLoader] = useState(false);
const [currentPage, setCurrentPage] = useState(1);
  let navigate = useNavigate();
  const FacialPackagingApi = async (formData) => {
    try {
      setLoader(true);

      let productResp = await axios.get(`${app.URL}/api/v1/admin/facialpackages/listing?limit=${formData.limit}&offset=${formData.offset}`, { headers: getHeaders() });
      console.log('xcdd', productResp?.data?.result?.data);
      productResp.data?.result?.data ? setPagesCount(productResp.data.result.data.count) : ' ';
      productResp?.data?.result?.data ? setrenderList(productResp.data.result.data.data) : '';
      productResp?.data?.result?.data && setLoader(false);
    } catch (err) {
      console.log(err);
    }
  };


    
//  useEffect(() => {
//    let header = ['Package Name', 'Facial Scan', '   Price ', 'Validity',"Status","Edit"];
//    setTableHeaders(header);
//    FacialPackagingApi()

//  }, []);
    const addFacialPackage = () => {
        console.log('added');
          navigate('/facialpackages/create', { replace: true });
        // console.log("added")
    };


    const editFacialPackage = (e) => {
      console.log(e.facialPackageId);
      localStorage.setItem('facialPackageId', e.facialPackageId);
          navigate('/facialpackages/update', { replace: true });
        console.log("editted")
    };


    console.log(renderList);
 const onPageChange = async (page, pageSize) => {
   console.log(page, pageSize);
   setPageSize(pageSize);
   setCurrentPage(page);
   if (!page) page = 1;
   let limit = pageSize;
   try {
     let reqObj = {
       limit: limit,
       offset: limit * (page - 1),
     };
     console.log('page Changed', reqObj);
     await FacialPackagingApi(reqObj);
   } catch (e) {
     console.log('Error');
     if (e.message) setErr(e.message);
     //  setTableShow(false);
   }
  };
  
  useEffect(() => {
     let header = ['Package Name', 'Vital Scan', '   Price ', 'Validity', 'Status', 'Edit'];
     setTableHeaders(header);
    let formData = { limit: pageSize, offset: 0 };
    const fetchData = async () => {
      await FacialPackagingApi(formData);
    };
    fetchData();
  }, []);
  return (
    <div>
      <ListinngCard
        heading='Vital Packages'
        buttonName='Add Vital Package'
        addButton={addFacialPackage}
        // onSearch={onFinish}
        // onSearchFailed={onFinishFailed}
        // searchItems={searchItems}

        tableHeaders={tableHeaders}
        tableRows={renderList}
        editButton={editFacialPackage}
        // editButton={editProduct}   --------    conditional rendering ask?

        // will use

        onPageChange={onPageChange}
        currentPage={currentPage}
        pagesCount={pagesCount}
        anuraListing={false}
        inventoryBatchListing={false}
        patientsListing={false}
        inventoryListing={false}
        userListings={false}
        storeListing={false}
        testResultListing={false}
        stockBalanceListing={false}
        productListing={false}
        BlogsListing={false}
        facialPackageListing={true}
        notShowSearch={true}
        // searchValue={searchData}

        // onChange={handleOnChange}
        loader={loader}
      />
    </div>
  );
}

export default FacialPackagesListing